import React, { useState } from "react";
import { Modal, Button, Spin } from "antd";
import { BlackXIcon, TickSuccess } from "../../../assets/icons";
import { httpService } from "../../../base/services/httpService.service";
import { useNotification } from "../../../base/hooks/useNotification";
import { useTranslation } from "../../../i18n/LanguageContext";

const RESOLVED_STATUS_VALUE = 2;

const ResolveTicketModal = ({ visible, onCancel, ticketId, getTicketById }) => {
   const { t } = useTranslation();
   const [loading, setLoading] = useState(false);
   const { api: notificationApi, notificationContextHolder } = useNotification();

   const handleResolve = async () => {
      try {
         setLoading(true);
         const formData = new FormData();
         formData.append("Status", RESOLVED_STATUS_VALUE);
         await httpService.put(
            `/Tickets/${ticketId}/change-status`,
            formData,
            () => {
               notificationApi.success("ticket", {
                  message: t("ticket-resolved-success-title"),
                  description: t("ticket-resolved-success-description")
               });
               getTicketById();
               onCancel();
            }
         );
      } catch (error) {
         notificationApi.error("ticket", {
            message: t("toast-oops-title"),
            description: t("resolve-ticket-error-description")
         });
      } finally {
         setLoading(false);
      }
   };

   return (
      <>
         {notificationContextHolder}
         <Modal
            open={visible}
            onCancel={loading ? null : onCancel}
            maskClosable={!loading}
            closable={false}
            className="deletemembermodal"
            footer={[
               <div className="footer-buttons" key="uniqueKey">
                  <Button
                     className="cencel-add-assessment-button"
                     key="cancel"
                     onClick={loading ? null : onCancel}
                     disabled={loading}
                  >
                     {t("cancel")}
                  </Button>
                  <Button
                     className="add-assessment-button"
                     key="resolve"
                     onClick={handleResolve}
                     disabled={loading}
                  >
                     {loading ? <Spin /> : t("mark-as-resolved-button")}
                  </Button>
               </div>
            ]}
         >
            <div>
               <img
                  src={BlackXIcon}
                  alt="BlackXIcon"
                  onClick={loading ? null : onCancel}
                  style={{ float: "right", cursor: "pointer" }}
               />
               <div className="delete-member-modal">
                  <img src={TickSuccess} alt="TickSuccess" />
                  <h1 className="resolve-title">{t("mark-ticket-resolved-title")}</h1>
               </div>
               <p className="delete-description">
                  <div>{t("mark-ticket-resolved-confirm-text")}</div>
               </p>
            </div>
         </Modal>
      </>
   );
};

export default ResolveTicketModal;
